export const USER_FEATURES = {
  KANBAN: "allowKanban",
  CRM: "allowCrm",
  AI: "ai",
};

export const hasUserFeatureAccess = (user, permission) =>
  user?.profile === "admin" ||
  (permission !== USER_FEATURES.AI && user?.[permission] === true);
